import React from 'react';
import Typography from '@mui/material/Typography';

export const CountryRiskColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Country Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>List Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Additional Remarks</Typography>
      </div>
    </>
  );
};

export default CountryRiskColumns;
